import {Observable}                  from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import MediaEventType            from '../../../../Solutions/Shared/Constants/MediaEventType';
import IMediaEventsStreamPayload from '../../../../Solutions/Shared/Interfaces/IMediaEventsStreamPayload';
import Playback                  from '../Playback';

const createPlayStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>,
    playbackStoreUpdate$: Observable<Playback>
): Observable<void> =>
    mediaEvents$
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            filter(([{type}, {isPlaying, isLoading}]) => type === MediaEventType.PLAY && !isPlaying && !isLoading),
            map(() => void 0)
        );

export default createPlayStream;